import DefaultTooltip from "../ui/tooltips/DefaultTooltip";
import ElementTooltipLabelSingle from "./ElementTooltipLabelSingle";

const _limit = 5;

function TooltipLabelSingle({ label, handle, isHidden }) {
  if (isHidden) {
    return null;
  }

  if (!label) {
    return null;
  }

  if (label.length < _limit) {
    return null;
  }

  return (
    <DefaultTooltip handle={handle}>
      <ElementTooltipLabelSingle label={label} />
    </DefaultTooltip>
  );
}

export default TooltipLabelSingle;
